import { useCallback, useLayoutEffect, useMemo } from 'react';
import get from 'lodash/get';
import { createStore, createHook, type StoreState } from 'react-sweet-state';
import { getLocale } from '@atlassian/jira-platform-utils-date-fns';
import { useLocale } from '@atlassian/jira-tenant-context-controller';
import { getLocalStorage } from '../../utils';

export const STORAGE_KEY = 'calendar.week.start.day';
const DEFAULT_WEEK_START_DAY = 0; // Sunday

type State = {
	weekStartDay: number;
};

const actions = {
	setWeekStartDay:
		(weekStartDay: number) =>
		({ setState }: StoreState<State>) =>
			setState({ weekStartDay }),
} as const;

type Actions = typeof actions;

// @ts-expect-error - TS2344 - Type '{ readonly setWeekStartDay: (weekStartDay: number) => ({ setState }: StoreState<State>) => void; }' does not satisfy the constraint 'Record<string, ActionThunk<State, { readonly setWeekStartDay: (weekStartDay: number) => ({ setState }: StoreState<State>) => void; }>>'.
const Store = createStore<State, Actions>({
	initialState: { weekStartDay: DEFAULT_WEEK_START_DAY },
	actions,
	name: 'JWMCalendarWeekStartDayStore',
});

// @ts-expect-error - TS2345 - Argument of type 'Store<State, { readonly setWeekStartDay: (weekStartDay: number) => ({ setState }: StoreState<State>) => void; }>' is not assignable to parameter of type 'Store<State, Record<string, ActionThunk<State, { readonly setWeekStartDay: (weekStartDay: number) => ({ setState }: StoreState<State>) => void; }>>>'.
const useWeekStartDayStore = createHook(Store);

export const useWeekStartDay = () => {
	const localStorage = useMemo(() => getLocalStorage(), []);

	const locale = useLocale();

	const [{ weekStartDay }, { setWeekStartDay: setWeekStartDayHook }] = useWeekStartDayStore();

	useLayoutEffect(() => {
		const startDay =
			localStorage.get(STORAGE_KEY) ??
			get(getLocale(locale), 'options.weekStartsOn', DEFAULT_WEEK_START_DAY);

		setWeekStartDayHook(startDay);
	}, [localStorage, locale, setWeekStartDayHook]);

	const setWeekStartDay = useCallback(
		(startDay: number) => {
			setWeekStartDayHook(startDay);

			try {
				localStorage.set(STORAGE_KEY, startDay);
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (e: any) {
				// do nothing
			}
		},
		[localStorage, setWeekStartDayHook],
	);

	return [weekStartDay, setWeekStartDay] as const;
};
